var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftOutlineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.781 33.231"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1189",
    d: "M41.784 33.231a3.617 3.617 0 01-2.556-1.058L7.728.71a2.411 2.411 0 00-4.114 1.7v27.207a3.613 3.613 0 01-3.615 3.611z",
    fill: "currentColor"
  })));
}

export default SvgLeftOutlineinline;